import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import ExternalLink from "components/externalLink/ExternalLink";
import LoginexLogo from "assets/images/loginex-logo.svg";
import { LoginImagePanel } from "./LoginImagePanel";

import "./Login.scss";

export const LoginLayout: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="login-split">
      <div className="login-split__form">
        <div className="login-split__form-inner">
          <div className="login-header">
            <img src={LoginexLogo} alt="Loginex" />
            <h1>Loginex</h1>
          </div>
          <div className="login-content">
            <Outlet />
          </div>
        </div>

        <div className="login-split__footer">
          <ul className="login-split__links">
            <li>© 2026 Loginex BV</li>
            <li>
              <ExternalLink
                href="https://www.loginex.ai/"
                label={t("aboutLoginex")}
              />
            </li>
            <li>
              <ExternalLink
                href="https://www.loginex.ai/privacy-statement/"
                label={t("Privacy statement")}
                dataTestId="privacy-statement"
              />
            </li>
            <li>
              <ExternalLink
                href="https://www.loginex.ai/cookies/"
                label={t("cookies")}
                dataTestId="cookies-link"
              />
            </li>
          </ul>
        </div>
      </div>

      <LoginImagePanel />
    </div>
  );
};
